import React from "react";
import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

const CampaignCardActions = ({ onDetail, onDelete, onArchive }) => {
  const { t } = useTranslation();
  return (
    <div className="campaignCard__actions">
      <Button className="campaignCard__detail" onClick={onDetail}>
        {t("Detail")}
      </Button>
      <Tooltip title={t("Delete")}>
        <Button icon="delete" onClick={onDelete} />
      </Tooltip>
      <Tooltip title={t("Archive")}>
        <Button icon="inbox" onClick={onArchive} />
      </Tooltip>
    </div>
  );
};

export default CampaignCardActions;
